<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="User">
        <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
          <v-card-title>
            Total Records : {{ total }}
            <v-spacer></v-spacer>
          </v-card-title>
          <v-text-field
            :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
            v-model="search"
            @input="searchData"
            append-icon="mdi-magnify"
            class="ml-auto mb-2"
            label="Search"
            hide-details
            single-line
            style="max-width:350px;"
          />
          <v-btn elevation="1" v-on:click="addUser()" :class="{ 'mt-2': $vuetify.breakpoint.xs }" color="accent">
            <v-icon left>mdi-plus</v-icon>
            Add
          </v-btn>
        </v-card-text>
        <v-divider class=" my-0 " />

        <v-data-table
          :headers="headers"
          :items="resultArray"
          disable-pagination
          :hide-default-footer="true"
        >
        <template v-slot:item.firstName="{ item }">
            <span class="text-capitalize">{{ item.firstName }} </span>
          </template>
          <template v-slot:item.lastName="{ item }">
            <span class="text-capitalize">{{ item.lastName }} </span>
          </template>

          <template v-slot:item.userRoleMaps="{ item }">
            <div v-for="roles in item.userRoleMaps" v-bind:value="roles.id" v-bind:key="roles.id">
              {{ roles.role.role }}
            </div>
          </template>
          <template v-slot:item.isActive="{ item }">
            {{ item.deletedAt ? 'Inactive' : 'Active' }}
          </template>
          <template v-slot:item.updatedAt="{ item }">
            {{ new Date(item.updatedAt).toLocaleDateString() }}
          </template>

          <template v-slot:item.actions="{ item }">
            <router-link :to="{ name: 'ViewUser', params: { adminUserID: item.id } }">
              <v-btn class="px-2 ml-1 ma-1" min-width="0" small>
                <v-icon color="black" small> mdi-eye</v-icon>
              </v-btn>
            </router-link>
            <router-link :to="{ name: 'EditUser', params: { adminUserID: item.id } }">
              <v-btn class="px-2 ml-1 ma-1" color="success" min-width="0" small>
                <v-icon small> mdi-pencil</v-icon>
              </v-btn>
            </router-link>

            <v-btn class="px-2 ml-1 ma-1" color="error" min-width="0" small v-if="!item.deletedAt" @click.prevent="deleteUser(item.id)">
              <v-icon small> mdi-delete</v-icon>
            </v-btn>
            <v-btn class="px-2 ml-1 ma-1" color="info" min-width="0" small @click.prevent="restoreUser(item.id)" v-if="item.deletedAt">
              <v-icon small> mdi-restore</v-icon>
            </v-btn>
          </template>
          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template>
        </v-data-table>
        <v-col >
          <v-row>
            <v-col cols="4" sm="3">
              <v-select
                v-model="pageSize"
                :items="pageSizes"
                label="Items per Page"
                @change="handlePageSizeChange"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="9">
              <v-pagination
                v-model="page"
                :length="totalPages"
                :total-visible="10"
                @input="handlePageChange"
              ></v-pagination>
            </v-col>
          </v-row>
      </v-col>
      </material-card>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import MaterialCard from '@/components/template/MaterialCard'
// import stores from '@/stores'
import constants from '@/utils/constants'
import _ from 'lodash'

export default {
  name: 'ListUser',
  components: {
    MaterialCard
  },
  props: {
    checkable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      search: '',
      resultArray: [],
      searchFilterArray: [],
      data: [],
      total: 0,
      isLoading: false,
      page: 1,
      totalPages: 0,
      pageSize: 10,
      pageSizes: [5, 10, 20],
      headers: [
        { text: 'First Name', value: 'firstName', sortable: true },
        { text: 'Last Name', value: 'lastName', sortable: true },
        { text: 'Email', value: 'email', sortable: true },
        { text: 'Department', value: 'department', sortable: true },
        { text: 'Role', value: 'userRoleMaps', sortable: true },
        { text: 'Status', value: 'isActive', sortable: true },
        { text: 'Updated Date', value: 'updatedAt', sortable: true },
        { text: 'Action', value: 'actions', sortable: false }
      ],
      models: [],
      loadingComponent: null
    }
  },
  created () {
    this.page = parseInt(this.$route.params.current)
    this.getUser()
  },
  watch: {
    page () {
      this.getUser()
    }
  },
  computed: {
    titleStack () {
      return ['Admin', 'Dashboard']
    },
    pageCount () {
      return Math.ceil(this.total / this.itemsPerPage)
    }
  },
  methods: {
    customSearch: function (value) {
      if (_.isEmpty(value)) {
        this.searchFilterArray = this.data
      } else {
        this.searchFilterArray = _.filter(
          this.data,
          item =>
            (item && item.firstName.toLowerCase().search(value.toLowerCase()) >= 0) ||
            (item && item.lastName.toLowerCase().search(value.toLowerCase()) >= 0) ||
            (item && item.email.toLowerCase().search(value.toLowerCase()) >= 0)
        )
        this.total = this.searchFilterArray.length
      }
    },
    addUser: async function () {
      this.$router.push({ name: 'SaveUser' })
      this.getUser()
    },

    getUser: async function () {
      try {
        this.isLoading = true
        const response = await http.get(`${constants.API_URL}/api/admin/all?page=${this.page - 1}&size=${this.pageSize}&search=${this.search}`)
        this.data = response.data
        this.resultArray = this.data.rows
        this.total = this.data.totalItems
        this.totalPages = this.data.totalPages
        this.isLoading = false
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.isLoading = false
        console.log('error in fetching User : ', errorMessage)
        return this.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      }
    },
    handlePageChange (value) {
      this.page = value
      this.$router.push({ name: 'User', params: { current: this.page } })
      this.getUser()
      this.isLoading = true
    },
    handlePageSizeChange (size) {
      this.pageSize = size
      this.page = 1
      this.getUser()
    },
    searchData () {
      if (this.search) {
        this.page = 1
        this.getUser()
      } else { this.getUser() }
    },
    deleteUser: async function (adminUserID) {
      let ref = this

      this.$dialog.warning({
        title: 'Delete User',
        text: 'Do you really want to <b>delete</b> this record?',
        actions: {
          false: {
            text: 'No'
          },
          true: {
            color: 'red',
            text: 'Yes',
            handle: async () => {
              try {
                ref.isLoading = true
                await http.delete(`${constants.API_URL}/api/admin/${adminUserID}`)
                ref.isLoading = false
                await ref.getUser()

                return ref.$dialog.info({
                  title: 'Success',
                  text: 'Deactivated User Successfully'
                })
              } catch (e) {
                ref.isLoading = false
                const errorMessage = (e && e.response && e.response.data.message) || e.message
                return ref.$dialog.error({
                  title: 'Error',
                  text: errorMessage
                })
              }
            } } }
      })
    },
    restoreUser: function (adminUserID) {
      let ref = this
      this.$dialog.warning({
        title: 'Restore User',
        text: 'Do you want to restore User?',
        actions: {
          false: {
            text: 'No'
          },
          true: {
            color: 'red',
            text: 'Yes',
            handle: async function () {
              try {
                ref.isLoading = true
                await http.put(`${constants.API_URL}/api/admin/restore/${adminUserID}`)
                ref.isLoading = false
                await ref.getUser()
                return ref.$dialog.info({
                  title: 'Success',
                  text: 'User restored successfully!'
                })
              } catch (e) {
                console.log(e)
                ref.isLoading = false
                const errorMessage = (e && e.response && e.response.data.message) || e.message
                console.log('error in restoring User : ', errorMessage)
                return ref.$dialog.error({
                  title: 'Error',
                  text: errorMessage
                })
              }
            } } }
      })
    }
  }
}
</script>
